import styled from 'styled-components';
import { MainHead } from '../../../components/common/head/MainHead';
import { useLayout } from '../../../hooks/screen/useLayout';
import { Icon } from '../../../components/common/icon/Icon';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { managedFarmPageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useAppDispatch } from '../../../hooks/store/useStore';
import { managedFarmSlice } from '../../../store/managedFarmSlice';
import {
  AddressSearchModal,
  SearchAddressItemForFieldMap,
} from '../ManagedFarmFieldMapPage/components/AddressSearchModal';

export const ManagedFarmSearchFieldPage = () => {
  const [isShowAddressSearchModal, setIsShowAddressSearchModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const managedFarmSliceActions = managedFarmSlice.actions;

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true }} />,
    fixedFooter: <></>,
    fixedHeaderHeight: 48,
    fixedFooterHeight: 0,
    shouldShowFooter: false,
  });

  const handleAddressSelected = (item: SearchAddressItemForFieldMap) => {
    setIsShowAddressSearchModal(false);
    dispatch(managedFarmSliceActions.setAddress(item.address));
    dispatch(managedFarmSliceActions.setCoordinates(item.coordinates));
    dispatch(managedFarmSliceActions.setPnu(item.pnu));

    navigate(managedFarmPageInfo.fieldMapPage.path);
  };
  return (
    <>
      <Container>
        <TitleSection>
          <Title>{'필지 주소 입력해서\n작업 등록하기'}</Title>
          <SubTitle>{'지번 주소로 입력해주세요.\n도로명 주소는 미지원합니다.'}</SubTitle>
        </TitleSection>
        <AddressSearchButtonWrapper>
          <AddressSearchButton onClick={() => setIsShowAddressSearchModal(true)}>
            <AddressSearchButtonTextWrapper>
              <AddressSearchButtonText>{'주소를 입력해주세요.'}</AddressSearchButtonText>
            </AddressSearchButtonTextWrapper>
            <Icon name={'Search'} size={'Large'} fill={'#858894'} />
          </AddressSearchButton>
        </AddressSearchButtonWrapper>
      </Container>

      {/* VWorld 주소 검색 모달 */}
      <AddressSearchModal
        isShow={isShowAddressSearchModal}
        onClose={() => setIsShowAddressSearchModal(false)}
        onAddressSelected={handleAddressSelected}
      />
    </>
  );
};

const Container = styled.div`
  display: flex;
  padding: 32px 0px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  align-self: stretch;

  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const Title = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */

  white-space: pre-wrap;
`;

const SubTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Body/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */

  white-space: pre-wrap;
`;

const AddressSearchButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;

  padding: 0px 24px;
`;

const AddressSearchButton = styled.button`
  height: 40px;

  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  padding: 8px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const AddressSearchButtonTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
`;

const AddressSearchButtonText = styled.span`
  overflow: hidden;
  color: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;
